<template>
  <article class="registration-steps">
    <h2 class="registration-steps__title">Passo 1</h2>

    <div class="registration-steps__wrapper">
      <h6 class="registration-steps__subtitle">Qual o tempo médio de sua consulta?</h6>

      <div class="registration-steps__form">
        <dr-field
          prefix="form1"
          v-bind:form.sync="form"
          v-bind:field.sync="form.intervals"
          v-bind:validators.sync="$v.form.intervals"
          :id="'intervals'"
          :ref="'intervals'"
        />
      </div>

      <button :disabled="$v.form.$invalid || sending" @click="next()" class="btn btn-primary">Avançar</button>
    </div>
  </article>
</template>

<script>
import drField from '@/components/form/field'
import { required } from 'vuelidate/lib/validators'

export default {
  props: ['formData'],
  components: {
    drField
  },
  data () {
    return {
      sending: false,
      form: {
        intervals: {
          size: 6,
          type: 'select',
          name: 'specialties',
          label: 'Tempo de consulta',
          required: true,
          placeholder: 'Informe o tempo médio de sua consulta',
          sending: false,
          value: '',
          options: [
            {
              id: 1,
              name: '15 minutos',
              interval: '00:15'
            },
            {
              id: 2,
              name: '30 minutos',
              interval: '00:30'
            },
            {
              id: 3,
              name: '45 minutos',
              interval: '00:45'
            },
            {
              id: 4,
              name: '1 hora',
              interval: '01:00'
            },
            {
              id: 5,
              name: '1 hora e 30 minutos',
              interval: '01:30'
            },
            {
              id: 6,
              name: '2 horas',
              interval: '02:00'
            }
          ]
        }
      }
    }
  },
  validations: {
    form: {
      intervals: {
        value: {
          required
        }
      }
    }
  },
  mounted () {
    this.fn_HIDE_PROGRESS()
  },
  methods: {
    next () {
      this.fn_SHOW_PROGRESS()
      this.sending = true
      let data = {
        appointmentInterval: this.form.intervals.options[this.form.intervals.value - 1].interval
      }
      this.$http.put('/doctor/doctor_office/appointment_interval', {appointment_interval: data}, this.$store.getters.getAuthHeader).then(
        (res) => {
          this.sending = false
          this.$emit('interval', data.appointmentInterval)
          this.$store.dispatch('setRegistrationAppointmentInterval', data.appointmentInterval)
          this.$router.push({path: '/register/' + this.$route.params.id + '/doctor-office/agenda/new/1'})
        }
      ).catch(
        (err) => {
          this.fn_HIDE_PROGRESS()
          console.log(err)
        }
      )
    }
  }
}
</script>
